<template>
          
<div class="inProduct_list"  v-if="productNav && productNav.length>0">
          
          <swiper :options="swiperOptionCov" ref="proSwiper">
            <swiper-slide class="inProduct_item" v-for="item in productNav" :key="item.id">
                <section class="inProductBox">
                    <div class="wrapper">
                        <div class="inProductItem">

                            <router-link :to='`/products/productlist/${item.scode}`' class="inProductItem_img">
                                <img :src="$root.$TEMP_URL+item.ico" />
                                <div class="inProductItem_text">{{item.name}}</div>
                            </router-link>
                            <div class="inProductItem_word">
                                <div class="titleBox">
                                    <div class="line"></div>
                                    <div class="name">{{item.name}}</div>
                                </div>
                                <div class="pagenavigation">
                                    <div class="fa fa-angle-up bannerSwiperLeft" ></div>
                                    <div class="fa fa-angle-down bannerSwiperRight"></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </swiper-slide>
            <!-- 底部 -->
            <swiper-slide class="inProduct_item footAuto">
                <Footer />
            </swiper-slide>
          </swiper>
		  <div class="mobileProductCover">
			  <div class="inProduct_item" v-for="item in productNav" :key="item.id">
			  <section class="inProductBox">
			      <div class="wrapper">
			          <div class="inProductItem">
			  
			              <router-link :to='`/products/productlist/${item.scode}`' class="inProductItem_img">
			                  <img :src="$root.$TEMP_URL+item.ico" />
			                  <div class="inProductItem_text">{{item.name}}</div>
			              </router-link>
			              <div class="inProductItem_word">
			                  <div class="titleBox">
			                      <div class="line"></div>
			                      <div class="name">{{item.name}}</div>
			                  </div>
			                  <div class="pagenavigation">
			                      <div class="fa fa-angle-up bannerSwiperLeft" ></div>
			                      <div class="fa fa-angle-down bannerSwiperRight"></div>
			                  </div>
			              </div>
			          </div>
			      </div>
			  </section>
			  </div>
			  <Footer />
		  </div>


      <div class="inProductNumBox">
          <!-- <div class="leftNum">01</div>
          <div class="line"></div>
          <div class="rightNum">07</div> -->
      </div>
		  
</div>
   
</template>

<script>
import { getProductNav,getProductNavcn } from '../../../api'

import 'swiper/dist/css/swiper.css'
import { swiper, swiperSlide } from 'vue-awesome-swiper'

import Footer from '../../../components/Footer/Footer'
export default {
  components:{
      swiper,
      swiperSlide,
      Footer
  },
  data() {
    var that = this;
    return {
        swiperOptionCov: {
               loop: false,　　//是否自动轮播
　　　　　　　　autoplay: false,  //l轮播间隔时间
              direction: 'vertical',
　　　　　　　　navigation: {
                  nextEl: '.bannerSwiperRight',
                  prevEl: '.bannerSwiperLeft',
              },
              speed:1200,
              followFinger : false,
              mousewheel: true,
              slidesPerView: 'auto',
              pagination: {
                    el: '.inProductNumBox',
                    type: 'custom',
                    renderCustom: function (swiper, current, total) {
                      return '<div class="leftNum currentClass">0' + (current==total?(current-1):current) + '</div>' +
                            ' <div class="line"></div> ' +
                            '<div class="rightNum totalClass">0' + (total-1) + '</div>';
                    },
              },
              on:{
                  slideChangeTransitionStart: function(){
                    // alert(this.activeIndex);
                    //让顶部滚动
                    if(this.activeIndex){
                      that.$parent.$parent.$refs.header.isScroll = true;
                    }else{
                      that.$parent.$parent.$refs.header.isScroll = false;
                    }
                  },
              },
    　　　},
         productNav:[],

    };
  },
  async created(){

      const isZhong = this.$parent.isZhong;
      let res;
      
      if(isZhong){
          res = await getProductNavcn();
      }else{
          res = await getProductNav();
      }


      this.productNav = res.data;

      //单独设置满屏
      document.querySelector('body').setAttribute('style', 'height:100%');
      document.querySelector('html').setAttribute('style', 'height:100%');
      document.querySelector("#app").setAttribute('style', 'height:100%');
      document.querySelector(".footBox").setAttribute('style', 'display:none');

  },
  beforeDestroy() {
      document.body.removeAttribute('style');
      document.querySelector('html').removeAttribute('style');
      document.querySelector("#app").removeAttribute('style');
      document.querySelector(".footBox").removeAttribute('style');
      // document.querySelector('#app').removeAttribute('style');
  }
   
};
</script>

<style lang="scss" scoped>
@import '../../../common/css/mixin.scss';

.inProduct_list{
  height: 100%;
}
.inProductBox {
  .wrapper {
    .inProductItem {
       display: flex;
       align-items: center;
      .inProductItem_img {
        width: 1150px;
        display: block;
        position: relative;
        overflow: hidden;
        img {
            width: 100%;
            height: 647px;
            @include compatible(transition,all 0.8s) ;
        }
        .inProductItem_text{
          position:absolute;
          width: 100%;
          height: 100%;
          z-index: 2;
          left: 0;
          top: 0;
          display: flex;
          justify-content: center;
          align-items: center;
          font-size: 30px;
          font-weight: bold;
          color: #fff;
          background: rgba(0, 0, 0, 0.5);
          opacity: 0;
          @include compatible(transition,all 0.6s) ;
        }
        &:hover{
           .inProductItem_text{
             opacity: 1;
           }
           img{
             @include compatible(transform,scale(1.1)) ;
           }
        }
      }

      .inProductItem_word {
        width: 100px;
        height: 647px;
        background: #fff;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        align-items: center;
        .titleBox {
          width: 36px;
          display: flex;
          justify-content: space-between;
          padding-top: 28px;
          max-height: 455px;
          overflow: hidden;
          .line{
            width: 1px;
            height: 56px;
            background: $themeColor;
          }
          .name{
            font-size: 18px;
            font-weight: bold;
            color: $themeColor;
            width: 16px;
            white-space: nowrap;
            -webkit-writing-mode: vertical-rl;
            -ms-writing-mode: bt-rl;
            writing-mode: vertical-rl;
          }

        }
        .pagenavigation {
          margin-bottom:32px;
          height: 120px;
          display: flex;
          flex-wrap: wrap;
          flex-direction: column;
          justify-content: space-between;
          .fa {
            font-size: 46px;
            color: #787878;
            cursor: pointer;
            @include compatible(transition,all 0.6s) ;
            position: relative;
            top: 0;
            &:hover{
              color: $themeColor;
              top: -5px;
            }

          }
        }
      }
    }
  }
}

* {
  -webkit-box-sizing: border-box; /* Safari<=5 Android<=3 */
  -moz-box-sizing: border-box; /* <=28 */
  box-sizing: border-box;
}
/* Custom
 * --------------------------------------- */
html, body {
    height: 100%;
}

.swiper-wrapper{
    transition-delay:.3s;
    }
    .swiper-container {
        width: 100%;
        height: 100%;
        background: url(./images/beijing_def.jpg) no-repeat;
        background-size: cover;
    }
    .swiper-slide {
        text-align: center;
        font-size: 18px;
        /* Center slide text vertically */
        display: -webkit-box;
        display: -ms-flexbox;
        display: -webkit-flex;
        display: flex;
        -webkit-box-pack: center;
        -ms-flex-pack: center;
        -webkit-justify-content: center;
        justify-content: center;
        -webkit-box-align: center;
        -ms-flex-align: center;
        -webkit-align-items: center;
        align-items: center;
        height: 100%;
        
        &.footAuto{
          height: auto;
        }
    }
	.swiper-slide:nth-child(2){
		color:#fff;}
	.swiper-slide p{
		transform:translateX(-200px);
		opacity:0;
		transition:all .4s;}
	.ani-slide p{
		transform:translateX(0);
		opacity:1;
		}

//添加右侧数字切换
.inProductNumBox{
   position: fixed;
   left: auto;
   right: 15%;
   top: 50%;
   height: 50px;
   margin-top: -25px;
   display: flex;
   justify-content: center;
   align-items: center;
   z-index: 100;
   width: 150px;
   >div{
     color: $themeColor;
     font-family: 'arial';
   }
   .leftNum {
     font-size: 32px;
  }

  .line {
    width: 36px;
    height: 1px;
    background: $themeColor;
    margin: 0 18px;
  }

  .rightNum {
    font-size: 18px;

  }
}

</style>
<style>
.inProductNumBox>div{
  color: #0d69af;
}
.inProductNumBox .leftNum {
    font-size: 30px;
}
.inProductNumBox .line {
  width: 36px;
  height: 1px;
  background: #0d69af;
  margin: 0 18px;
}
.inProductNumBox .rightNum {
  font-size: 20px;
}
</style>
 


// WEBPACK FOOTER //
// src/pages/Products/ProductCover/ProductCover.vue